module.exports = __webpack_public_path__ + "img/mouse.4225512c.png";